import { Container, Row, Col, Card, Badge, Form, Button } from "react-bootstrap";
import EDCLogo from "../img/edc.png";
import ETMFLogo from "../img/ETMF.png";
import IWRSLogo from "../img/IWRS.png";
import { studyOnboardingService } from "../APIServices/studyOnboarding";
import { useEffect, useState } from "react";
import { studyAccessManagement } from "../APIServices/studyAccessManagement";
import Navbar from "./Navbar";
import { userServices } from "../APIServices/userServices";
import Footer from "./Footer";

const AppSelectionPage = () => {
  const [application, setApplication] = useState([])
  const studyId = JSON.parse(localStorage.getItem("studyId"));
  const studyLength = Number(JSON.parse(localStorage.getItem("studyLength")));
  const [projectId, setProjectId] = useState("");
  const [projectLabel, setProjectLabel] = useState("");
  const [studyLabel, setStudyLabel] = useState("");
  const [clientLabel, setClientLabel] = useState("");

  const getProjectIdByStudyId = async () => {
    let projectId = await studyOnboardingService.getProjectIdByStudyId(studyId);
    setProjectId(projectId?.data?.project_id);
    setProjectLabel(projectId?.data?.projectLabel);
    setStudyLabel(projectId?.data?.studyLabel);
    setClientLabel(projectId?.data?.sponsorName);
  };

  const getTotalAssignedApps = async () => {
    let data = await studyOnboardingService.getTotalAssignedApps(studyId)
    setApplication(data?.data || [])
  }

  const [DBPEDCPermission, setDBPEDCPermission] = useState([]);
  const [DVEDCPermission, setDVEDCPermission] = useState([]);
  const [LiveEDCPermission, setLiveEDCPermission] = useState([]);
  const [QCEDCPermission, setQCEDCPermission] = useState([]);
  const [SDVLiveEDCPermission, setSDVLiveEDCPermission] = useState([]);
  const [SDVQCEDCPermission, setSDVQCEDCPermission] = useState([]);

  const [DBPEIWRSPermission, setDBPEIWRSPermission] = useState([]);
  const [LiveEIWRSPermission, setLiveEIWRSPermission] = useState([]);
  const [QCEIWRSPermission, setQCEIWRSPermission] = useState([]);

  const [DBPETMFPermission, setDBPETMFPermission] = useState([]);
  const [LiveETMFPermission, setLiveETMFPermission] = useState([]);
  const [QCETMFPermission, setQCETMFPermission] = useState([]);

  const [studyPermissionId, setStudyPermissionId] = useState("");
  const [studyManagement, setStudyManagement] = useState("");

  const [EIWRSPermissionId, setEIWRSPermissionId] = useState("");
  const [EIWRSManagement, setEIWRSManagement] = useState("");

  const [ETMFPermissionId, setETMFPermissionId] = useState("");
  const [ETMFManagement, setETMFManagement] = useState("");

  const [assignStudyPermission, setAssignStudyPermission] = useState("");

  const [DBPEDCCheck, setDBPEDCCheck] = useState("");
  const [DVEDCCheck, setDVEDCCheck] = useState("");
  const [LiveEDCCheck, setLiveEDCCheck] = useState("");
  const [QCEDCCheck, setQCEDCCheck] = useState("");
  const [SDVLiveEDCCheck, setSDVLiveEDCCheck] = useState("");
  const [SDVQCEDCCheck, setSDVQCEDCCheck] = useState("");

  const [DBPEIWRSCheck, setDBPEIWRSCheck] = useState("");
  const [LiveEIWRSCheck, setLiveEIWRSCheck] = useState("");
  const [QCEIWRSCheck, setQCEIWRSCheck] = useState("");

  const [DBPETMFCheck, setDBPETMFCheck] = useState("");
  const [LiveETMFCheck, setLiveETMFCheck] = useState("");
  const [QCETMFCheck, setQCETMFCheck] = useState("");

  const [studyStatus, setStudyStatus] = useState("");
  const [studyStatusData, setStudyStatusData] = useState("");

  const viewSelectedItemWithSign = async () => {
    setStudyStatus("active");
    setStudyStatusData("active");
    
    let EDCPermission = await studyAccessManagement.getStudyUserPermission(
      studyId,
      "edc"
    );

    setStudyPermissionId(
      EDCPermission?.permissionId ? EDCPermission?.permissionId : ""
    );
    setStudyManagement(EDCPermission?.permissionRole);
    setDBPEDCPermission(EDCPermission?.DBPPermission);
    setDVEDCPermission(EDCPermission?.DVPermission);
    setLiveEDCPermission(EDCPermission?.LivePermission);
    setQCEDCPermission(EDCPermission?.QCPermission);
    setSDVLiveEDCPermission(EDCPermission?.SDVLivePermission);
    setSDVQCEDCPermission(EDCPermission?.SDVQCPermission);
    setDBPEDCCheck(EDCPermission?.DBPCheck);
    setDVEDCCheck(EDCPermission?.DVCheck);
    setLiveEDCCheck(EDCPermission?.LiveCheck);
    setQCEDCCheck(EDCPermission?.QCCheck);
    setSDVLiveEDCCheck(EDCPermission?.SDVLiveCheck);
    setSDVQCEDCCheck(EDCPermission?.SDVQCCheck);

    let IWRSPermission = await studyAccessManagement.getStudyUserPermission(
      studyId,
      "eiwrs"
    );

    setEIWRSPermissionId(
      IWRSPermission?.permissionId ? IWRSPermission?.permissionId : ""
    );
    setEIWRSManagement(IWRSPermission?.permissionRole);
    setDBPEIWRSPermission(IWRSPermission?.DBPPermission);
    setLiveEIWRSPermission(IWRSPermission?.LivePermission);
    setQCEIWRSPermission(IWRSPermission?.QCPermission);
    setDBPEIWRSCheck(IWRSPermission?.DBPCheck);
    setLiveEIWRSCheck(IWRSPermission?.LiveCheck);
    setQCEIWRSCheck(IWRSPermission?.QCCheck);
    
    let ETMFPermission = await studyAccessManagement.getStudyUserPermission(
      studyId,
      "etmf"
    );

    setETMFPermissionId(
      ETMFPermission?.permissionId ? ETMFPermission?.permissionId : ""
    );
    setETMFManagement(ETMFPermission?.permissionRole);
    setDBPETMFPermission(ETMFPermission?.DBPPermission);
    setLiveETMFPermission(ETMFPermission?.LivePermission);
    setQCETMFPermission(ETMFPermission?.QCPermission);
    setDBPETMFCheck(ETMFPermission?.DBPCheck);
    setLiveETMFCheck(ETMFPermission?.LiveCheck);
    setQCETMFCheck(ETMFPermission?.QCCheck);
  };

  const loginStudyEDCPanel = async () => {
    localStorage.removeItem("studyTabs");
    localStorage.setItem("role", JSON.stringify("edc"));
    localStorage.setItem("clientLabel", JSON.stringify(clientLabel));
    localStorage.setItem("projectLabel", JSON.stringify(projectLabel));
    localStorage.setItem("previousRole", JSON.stringify("user"));
    localStorage.setItem("loginType", JSON.stringify(studyLength > 1 ? "multiStudies" : "singleStudy"));
    localStorage.setItem("studyStatus", JSON.stringify(studyStatus));
    localStorage.setItem("studyStatusData", JSON.stringify(studyStatusData));
    if (studyLength > 1) {
      localStorage.removeItem("studyId");
      localStorage.removeItem("studyName");
      localStorage.removeItem("projectName");
    }
    localStorage.setItem(
      "StudyMode",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? "DBP Mode"
          : assignStudyPermission === "DV"
            ? "DV Mode"
            : assignStudyPermission === "LIVE"
              ? "Live Mode"
              : assignStudyPermission === "QC"
                ? "QC Mode"
                : assignStudyPermission === "SDVLIVE"
                  ? "SDV Live Mode"
                  : assignStudyPermission === "SDVQC"
                    ? "SDV QC Mode"
                    : "No Mode"
      )
    );

    window.location.href = `/edc/${studyId}`;
    localStorage.setItem(
      "studyPermissionData",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? DBPEDCPermission[0]
          : assignStudyPermission === "DV"
            ? DVEDCPermission[0]
            : assignStudyPermission === "LIVE"
              ? LiveEDCPermission[0]
              : assignStudyPermission === "QC"
                ? QCEDCPermission[0]
                : assignStudyPermission === "SDVLIVE"
                  ? SDVLiveEDCPermission[0]
                  : assignStudyPermission === "SDVQC"
                    ? SDVQCEDCPermission[0]
                    : ""
      )
    );
    localStorage.setItem(
      "studyPermissionId",
      JSON.stringify(studyPermissionId)
    );
    localStorage.setItem("studyManagement", JSON.stringify(studyManagement));
  };

  const loginStudyEIWRSPanel = async () => {
    localStorage.removeItem("studyTabs");
    localStorage.setItem("role", JSON.stringify("eiwrs"));
    localStorage.setItem("clientLabel", JSON.stringify(clientLabel));
    localStorage.setItem("projectLabel", JSON.stringify(projectLabel));
    localStorage.setItem("previousRole", JSON.stringify("user"));
    localStorage.setItem("loginType", JSON.stringify(studyLength > 1 ? "multiStudies" : "singleStudy"));
    localStorage.setItem("studyStatus", JSON.stringify(studyStatus));
    localStorage.setItem("studyStatusData", JSON.stringify(studyStatusData));
    if (studyLength > 1) {
      localStorage.removeItem("studyId");
      localStorage.removeItem("studyName");
      localStorage.removeItem("projectName");
    }
    localStorage.setItem(
      "StudyMode",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? "DBP Mode"
          : assignStudyPermission === "LIVE"
            ? "Live Mode"
            : assignStudyPermission === "QC"
              ? "QC Mode"
              : ""
      )
    );

    window.location.href = `/eiwrs/${studyId}`;
    localStorage.setItem(
      "studyPermissionData",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? DBPEIWRSPermission[0]
          : assignStudyPermission === "LIVE"
            ? LiveEIWRSPermission[0]
            : assignStudyPermission === "QC"
              ? QCEIWRSPermission[0]
              : ""
      )
    );
    localStorage.setItem(
      "studyPermissionId",
      JSON.stringify(EIWRSPermissionId)
    );
    localStorage.setItem("studyManagement", JSON.stringify(EIWRSManagement));
  };

  const loginStudyETMFPanel = async () => {
    localStorage.removeItem("studyTabs");
    localStorage.setItem("role", JSON.stringify("etmf"));
    localStorage.setItem("clientLabel", JSON.stringify(clientLabel));
    localStorage.setItem("projectLabel", JSON.stringify(projectLabel));
    localStorage.setItem("previousRole", JSON.stringify("user"));
    localStorage.setItem("loginType", JSON.stringify(studyLength > 1 ? "multiStudies" : "singleStudy"));
    localStorage.setItem("studyStatus", JSON.stringify(studyStatus));
    localStorage.setItem("studyStatusData", JSON.stringify(studyStatusData));
    if (studyLength > 1) {
      localStorage.removeItem("studyId");
      localStorage.removeItem("studyName");
      localStorage.removeItem("projectName");
    }
    localStorage.setItem(
      "StudyMode",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? "DBP Mode"
          : assignStudyPermission === "LIVE"
            ? "Live Mode"
            : assignStudyPermission === "QC"
              ? "QC Mode"
              : ""
      )
    );

    window.location.href = `/etmf/${studyId}`;
    localStorage.setItem(
      "studyPermissionData",
      JSON.stringify(
        assignStudyPermission === "DBP"
          ? DBPETMFPermission[0]
          : assignStudyPermission === "LIVE"
            ? LiveETMFPermission[0]
            : assignStudyPermission === "QC"
              ? QCETMFPermission[0]
              : ""
      )
    );
    localStorage.setItem(
      "studyPermissionId",
      JSON.stringify(ETMFPermissionId)
    );
    localStorage.setItem("studyManagement", JSON.stringify(ETMFManagement));
  };

  const [greeting, setGreeting] = useState("");
  const userName = JSON.parse(localStorage.getItem("firstName"));
  const getGreeting = () => {
    const currentTime = new Date().getHours();
    let greeting;

    if (currentTime >= 5 && currentTime < 12) {
      greeting = "Good Morning";
    } else if (currentTime >= 12 && currentTime < 18) {
      greeting = "Good Afternoon";
    } else {
      greeting = "Good Evening";
    }
    setGreeting(greeting);
  };

  useEffect(() => {
    getGreeting();
  }, []);

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    if (studyId) {
      getTotalAssignedApps()
      getProjectIdByStudyId()
      viewSelectedItemWithSign();
    }
  }, [studyId]);

  useEffect(() => {
    if (studyId && projectId) {
      viewSelectedItemWithSign();
    }
  }, [studyId, projectId]);


  console.log(">>44", DBPEIWRSCheck , LiveEIWRSCheck , QCEIWRSCheck);
  

  return (
    <>
      <div style={{ background: "var(--blue)" }}>
        <div className="hstack justify-content-between border-bottom border-secondary px-2 py-1">
          <h4 className="text-white m-0">Galax®</h4>
          <Button
            onClick={logout}
            variant="outline-danger"
            className="p-1 px-2 border-0 br3 hstack"
            style={{ fontSize: 13 }}
            title="Sign out from panel"
          >
            <i className="fa-solid fa-right-from-bracket me-1" style={{marginBottom: -2}}></i><span>Signout</span>
          </Button>
        </div>
      </div>
      <div className="p-3 text-center border-bottom">
        <h4 className="mb-0">{greeting}! {userName}</h4>
        <p className="m-0">You can access your applications</p>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 152px)" }}>
        <Container>
          <Row>
            {application?.some(item => item.category === "edc") &&
              <Col lg={3} sm={12} md={6} className="g-4">
                <Card className="mb-2 bg-light shadow-sm border">
                  <Card.Body>
                    <div className="d-flex gap-3 mb-1">
                      <div className="study_icopn lh-1">
                        <div className="bg-white shadow-sm p-1">
                          <img
                            src={EDCLogo}
                            alt=""
                            style={{ width: 50, height: 50 }}
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <Form.Label className="mb-1 d-block fw-bold">
                          Galax EDC
                        </Form.Label>
                        <Form.Label className="mb-1 d-block">
                          <span className="fw-medium">ProjectId</span> : {projectLabel}
                        </Form.Label>
                        <Form.Label className="d-block">
                          <span className="fw-medium">StudyId</span> : {studyLabel}
                        </Form.Label>
                      </div>
                    </div>
                    <div className="hstack gap-2">
                      <Form.Select
                        className="w-100 py-1 px-2 border  "
                        style={{ fontSize: 11 }}
                        disabled={!(DBPEDCCheck || DVEDCCheck || LiveEDCCheck || SDVLiveEDCCheck || QCEDCCheck || SDVQCEDCCheck)}
                        onChange={(e) => setAssignStudyPermission(e.target.value)}
                      >
                        <option>{!(DBPEDCCheck || DVEDCCheck || LiveEDCCheck || SDVLiveEDCCheck || QCEDCCheck || SDVQCEDCCheck) ? "No Environment" : "Select Environment"}</option>
                        <>
                          {DBPEDCCheck ? (
                            <option value={"DBP"}>DBP Mode</option>
                          ) : (
                            ""
                          )}
                          {DVEDCCheck ? (
                            <option value={"DV"}>DV Mode</option>
                          ) : (
                            ""
                          )}
                          {LiveEDCCheck ? (
                            <option value={"LIVE"}>Live Mode</option>
                          ) : (
                            ""
                          )}
                          {SDVLiveEDCCheck ? (
                            <option value={"SDVLIVE"}>SDV Live Mode</option>
                          ) : (
                            ""
                          )}
                          {QCEDCCheck ? (
                            <option value={"QC"}>QC Mode</option>
                          ) : (
                            ""
                          )}
                          {SDVQCEDCCheck ? (
                            <option value={"SDVQC"}>SDV QC Mode</option>
                          ) : (
                            ""
                          )}
                        </>
                      </Form.Select>
                      <button
                        disabled={!assignStudyPermission}
                        onClick={loginStudyEDCPanel} className="updateProfile">Login</button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            }
            {application?.some(item => item.category === "eiwrs") &&
              <Col lg={3} sm={4} md={6} className="g-4">
                <Card className="mb-2 bg-light shadow-sm border">
                  <Card.Body>
                    <div className="d-flex gap-3 mb-1">
                      <div className="study_icopn lh-1">
                        <div className="bg-white shadow-sm p-1">
                          <img
                            src={IWRSLogo}
                            alt=""
                            style={{ width: 50, height: 50 }}
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <Form.Label className="mb-1 d-block fw-bold">
                          Galax eIWRS
                        </Form.Label>
                        <Form.Label className="mb-1 d-block">
                          <span className="fw-medium">ProjectId</span> : {projectLabel}
                        </Form.Label>
                        <Form.Label className="d-block">
                          <span className="fw-medium">StudyId</span> : {studyLabel}
                        </Form.Label>
                      </div>
                    </div>
                    <div className="hstack gap-2">
                      <Form.Select
                        className="w-100 py-1 px-2 border  "
                        style={{ fontSize: 11 }}
                        disabled={!(DBPEIWRSCheck || LiveEIWRSCheck || QCEIWRSCheck)}
                        onChange={(e) => setAssignStudyPermission(e.target.value)}
                      >
                        <option>{!(DBPEIWRSCheck || LiveEIWRSCheck || QCEIWRSCheck) ? "No Environment" : "Select Environment"}</option>
                        <>
                          {DBPEIWRSCheck ? (
                            <option value={"DBP"}>DBP Mode</option>
                          ) : (
                            ""
                          )}
                          {LiveEIWRSCheck ? (
                            <option value={"LIVE"}>Live Mode</option>
                          ) : (
                            ""
                          )}
                          {QCEIWRSCheck ? (
                            <option value={"QC"}>QC Mode</option>
                          ) : (
                            ""
                          )}
                        </>
                      </Form.Select>
                      <button
                        disabled={!assignStudyPermission}
                        onClick={loginStudyEIWRSPanel} className="updateProfile">Login</button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            }
            {application?.some(item => item.category === "etmf") &&
              <Col lg={3} sm={4} md={6} className="g-4">
                <Card className="mb-2 bg-light shadow-sm border">
                  <Card.Body>
                    <div className="d-flex gap-3 mb-1">
                      <div className="study_icopn lh-1">
                        <div className="bg-white shadow-sm p-1">
                          <img
                            src={IWRSLogo}
                            alt=""
                            style={{ width: 50, height: 50 }}
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <Form.Label className="mb-1 d-block fw-bold">
                          Galax ETMF
                        </Form.Label>
                        <Form.Label className="mb-1 d-block">
                          <span className="fw-medium">ProjectId</span> : {projectLabel}
                        </Form.Label>
                        <Form.Label className="d-block">
                          <span className="fw-medium">StudyId</span> : {studyLabel}
                        </Form.Label>
                      </div>
                    </div>
                    <div className="hstack gap-2">
                      <Form.Select
                        className="w-100 py-1 px-2 border  "
                        style={{ fontSize: 11 }}
                        disabled={!(DBPETMFCheck || LiveETMFCheck || QCETMFCheck)}
                        onChange={(e) => setAssignStudyPermission(e.target.value)}
                      >
                        <option>{!(DBPETMFCheck || LiveETMFCheck || QCETMFCheck) ? "No Environment" : "Select Environment"}</option>
                        <>
                          {DBPETMFCheck ? (
                            <option value={"DBP"}>DBP Mode</option>
                          ) : (
                            ""
                          )}
                          {LiveETMFCheck ? (
                            <option value={"LIVE"}>Live Mode</option>
                          ) : (
                            ""
                          )}
                          {QCETMFCheck ? (
                            <option value={"QC"}>QC Mode</option>
                          ) : (
                            ""
                          )}
                        </>
                      </Form.Select>
                      <button
                        disabled={!assignStudyPermission}
                        onClick={loginStudyETMFPanel} className="updateProfile">Login</button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            }
          </Row>
        </Container>
      </div>
      <Footer/>
    </>
  )
}

export default AppSelectionPage;
